import styled from 'styled-components';

import NbPointOfSalesMacaron from 'components/Notebook/NbPointOfSalesMacaron';

const NotebookImageContainer = styled.div`
  .notebook-online-main {
    position: relative;
  }

  .full-content {
    margin: -20px;
  }

  .notebook-online-image-container {
    width: 100%;
  }

  .notebook-online-image {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 4px;
  }

  .notebook-online-image-full {
    border-radius: 4px 4px 0 0;
  }

  .notebook-online-dn-client {
    position: absolute;
    right: 20px;
    top: 50px;
  }
`;

const MarketNotebook = ({ name, dnClient, imagePath, fullContent = true }) => (
  <NotebookImageContainer>
    <div
      className={'notebook-online-main' + (fullContent ? ' full-content' : '')}
    >
      <div className="notebook-online-image-container">
        <img
          src={imagePath}
          className={
            'notebook-online-image' +
            (fullContent ? ' notebook-online-image-full' : '')
          }
          alt={`image of the market ${name}`}
        />
      </div>
      <div className="notebook-online-dn-client">
        <NbPointOfSalesMacaron nbRestaurants={dnClient} />
      </div>
    </div>
  </NotebookImageContainer>
);

export default MarketNotebook;
